
export default {
  name: 'RandomUuidGenerator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "What Is The Purpose Of A UUID?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The purpose of a UUID is to provide a unique and standardized way to identify information, objects, or entities in various digital applications. It helps ensure distinct and predictable identification."
        }
      },{
        "@type": "Question",
        "name": "Is It Necessary To Format A Random UUID With Hyphens And Hex Characters?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. You don't need to format a random UUID with hyphens and hexadecimal characters. But, using hyphens and specific characters makes it easier for people to read and work with UUIDs."
        }
      },{
        "@type": "Question",
        "name": "What Is The Role Of Randomness In Generating Random UUIDs?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Randomness in generating UUIDs enhances their uniqueness and unpredictability. So, they are suitable for security-sensitive uses."
        }
      },{
        "@type": "Question",
        "name": "Are Random UUIDs Truly Unique?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Random UUIDs are designed to be highly unique, and the vast number of possible combinations generated through randomness makes it exceedingly unlikely for two UUIDs to be the same."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        numbers: 1
      })
    }
  },
  methods: {
    RandomUuidGenerator() {
        this.form.post(`/tool/random-uuid-generator`, { progress: false }).then(res => {
          this.data = Object.values(res.data);
        }).catch(e => {
          console.log(e);
        });
    },
    formatUUIDs(data) {
      return data.flat().join('\n');
    },
    onSample(){
        this.form.numbers = 12;
    },
    onReset(){
        this.form.reset();
        this.data = '';
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
}
